function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 5a5 5 0 015 5v10a5 5 0 01-5 5H10a5 5 0 01-5-5V10a5 5 0 015-5h10z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20 7H10a3 3 0 00-2.995 2.824L7 10v10a3 3 0 002.824 2.995L10 23h10a3 3 0 002.995-2.824L23 20V10a3 3 0 00-2.824-2.995L20 7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 18v2h-6v-2h6zm-8 0v2h-2v-2h2zm0-4v2h-2v-2h2zm8 0v2h-6v-2h6zm0-4v2h-6v-2h6zm-8 0v2h-2v-2h2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 15a5 5 0 015 5v4a5 5 0 01-5 5h-4a5 5 0 01-5-5v-4a5 5 0 015-5h4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24 17h-4a3 3 0 00-2.995 2.824L17 20v4a3 3 0 002.824 2.995L20 27h4a3 3 0 002.995-2.824L27 24v-4a3 3 0 00-2.824-2.995L24 17z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.266 19.325l-3.307 3.308-1.225-1.226-1.234 1.234 2.459 2.459 4.541-4.541z"
});

function SvgQMaScoredTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgQMaScoredTypeIcon;